import { Grid } from '../../../../Common/Grid'
import { Typography } from '@fullscreendigital/carrefour-dex-fe'
import { TitleHeader } from '../../../Common/TitleHeader'
import { useNavigate } from 'react-router-dom'
import { TruckCard } from '../../../../admin/Common/TruckCard'
import { URLS } from '../../../constants'
import { useNotification } from '../../../../../../hooks'
import { useQuery } from 'react-query'
import { makeCoreGetRequest } from '../../../../../../utils/api'
import { formatErrorMessage } from '../../../../../../utils/formatting'
import { CircularProgress } from '@mui/material'

const Delivery = () => {
  const navigate = useNavigate()
  const { showNotification } = useNotification()

  const {
    data: truckList,
    isLoading,
    isError
  } = useQuery(
    'validationTrucks',
    async () => {
      return await makeCoreGetRequest('/shop-reception-mobile/truck/shop/validations', null)
    },
    {
      onError: error => {
        showNotification({
          message: `Error while fetching trucks. ${formatErrorMessage(error)}`,
          type: 'error'
        })
      }
    }
  )

  if (isLoading) {
    return <CircularProgress color="primary" style={{ margin: '40px auto' }} disableShrink />
  }

  if (isError) {
    return (
      <Typography
        variant="light"
        component="p"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
      >
        A aparut o eroare la obtinerea datelor.
      </Typography>
    )
  }

  let items = [
    <TitleHeader title="VALIDARE LIVRARE" />,
    truckList &&
      truckList?.map((truck: any, index) => (
        <TruckCard
          key={truck.id}
          onClick={() => {
            navigate(URLS.AUTH_DELIVERY_DETAIL, { state: { truck } })
          }}
          truck={truck}
        />
      ))
  ]

  if (!truckList || truckList.length === 0) {
    items.push(
      <Typography
        variant="light"
        component="p"
        style={{ textAlign: 'center', textTransform: 'uppercase' }}
      >
        nu existǎ camioane de validat
      </Typography>
    )
  }

  return (
    <Grid gridContainerStyle={{ marginTop: '20px' }} maxWidth="xs" items={items} itemsPerRow={1} />
  )
}

export default Delivery
